import React from "react";
import { Box, CircularProgress, Container, Typography } from "@mui/material";

interface SearchContentContainerProps {
  isLoading: boolean;
  data: any[];
  LoadingComponent?: React.ComponentType;
  ContentComponent: React.ComponentType<any>;
  componentProps?: any;
  loadingText?: string;
  emptyTitle?: string;
  emptyMessage?: string;
}

const SearchContentContainer = ({
  isLoading,
  data,
  LoadingComponent,
  ContentComponent,
  componentProps = {},
  loadingText = "Loading...",
  emptyTitle = "No Items Found",
  emptyMessage = "Try adjusting your search or filter criteria",
}: SearchContentContainerProps) => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Box sx={{ mt: 4, position: "relative", minHeight: "400px" }}>
          {isLoading ? (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <CircularProgress size={24} sx={{ mr: 2 }} />
                <Typography variant="body1" color="text.secondary">
                  {loadingText}
                </Typography>
              </Box>
              {LoadingComponent ? <LoadingComponent /> : null}
            </Box>
          ) : data.length > 0 ? (
            <ContentComponent {...componentProps} data={data} />
          ) : (
            <Box
              sx={{
                textAlign: "center",
                py: 8,
                backgroundColor: "background.paper",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Typography variant="h6" color="text.secondary" gutterBottom>
                {emptyTitle}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {emptyMessage}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default SearchContentContainer;
